import * as React from 'react';
import { Link } from 'react-router-dom';
import { getSearchQuery } from '../utils/globals';
import { parseUrl, stringifyUrl } from 'query-string';
/**
 * Strip out 'query' from url search query params
 */
const withoutSearchQuery = () => {
    const searchQuery = getSearchQuery();
    if (searchQuery.length) {
        let parsedSearchQuery = parseUrl(window.location.search);
        delete parsedSearchQuery.query['query'];
        return stringifyUrl(parsedSearchQuery);
    }
    return window.location.search;
};
const RouterLink = ({ 'data-test-id': dataTestId, children, to: pathname, ...props }) => {
    const search = withoutSearchQuery();
    return (React.createElement(Link, Object.assign({ to: { pathname, search }, "data-testid": dataTestId }, props), children));
};
RouterLink.displayName = 'RouterLink';
/** @external */
export default RouterLink;
//# sourceMappingURL=RouterLink.js.map